export const isFirstVisit = () => {
    const hasVisited = localStorage.getItem('hasVisitedBefore');
    if (!hasVisited) {
        localStorage.setItem('hasVisitedBefore', 'true');
        return true;
    }
    return false;
};
